import React, { useState, useEffect, useRef } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import { API_URL, BASE_URL } from '../Config';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import config from "../common/Config";
import { setTableWidths, getTableWidths } from "../../data/postAPi";

const PickingHistory = () => {
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [selectedRole, setSelectedRole] = useState('');
  const [newSales, setNewSales] = useState([]);
  const [draw, setDraw] = useState(1);
  const [start, setStart] = useState(0);
  const [length, setLength] = useState(50);
  const [colWidths, setColWidths] = useState([]);
  const tableRef = useRef(null);
  const userId = localStorage.getItem("userId");
  const tableName = "pickingHistoryTable";
  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
  const debouncedSetTableWidths = useRef(
    debounce((userId, tableName, widths) => {
      setTableWidths(userId, tableName, widths);
    }, 500)
  ).current;
  const accessToken = localStorage.getItem('accessToken');

  const getInitialColWidths = () => {
    const baseWidth = 120;
    const columnCount = accessToken === 'tss' || accessToken === 'tsc' ? 8 : 6;
    return new Array(columnCount).fill(baseWidth);
  };

  const startResizing = (columnIndex, e) => {

    e.preventDefault();
    const startX = e.clientX;
    const startWidth = colWidths[columnIndex] || 120;

    const onMouseMove = (moveEvent) => {
      const newWidth = Math.max(50, startWidth + moveEvent.clientX - startX);
      setColWidths((widths) => {
        const updated = [...widths];
        updated[columnIndex] = newWidth;
        debouncedSetTableWidths(userId, tableName, updated);

        $(`#neworderTable thead th:eq(${columnIndex})`).css('width', newWidth + 'px');

        return updated;
      });
    };

    const onMouseUp = () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };

    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  };

  useEffect(() => {
    async function fetchWidths() {
      try {
        const res = await getTableWidths(userId, tableName);
        if (res?.data?.widths && Array.isArray(res.data.widths) && res.data.widths.length > 0) {
          setColWidths(res.data.widths);
        } else {
          setColWidths(getInitialColWidths());
        }
      } catch (e) {
        setColWidths(getInitialColWidths());
      }
    }
    fetchWidths();
  }, [accessToken]);

  const handleSubmit = (e) => {
    e.preventDefault();
    fetchData();
  };

  const fetchData = async () => {
    const formData = new FormData();
    formData.append('searchByFromdate', fromDate);
    formData.append('searchByTodate', toDate);
    formData.append('draw', draw);
    formData.append('start', start);
    formData.append('length', length);
    formData.append('role', selectedRole);

    const apiUrl = `${API_URL}/picking/get`;
    const accessToken = localStorage.getItem('accessToken');

    if (accessToken === null) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error('Failed to fetch new sales data');
      }

      const data = await response.json();
      setNewSales(Array.isArray(data.data) ? data.data : []);
    } catch (error) {
      console.error('Error fetching new sales data:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [fromDate, toDate, selectedRole]);

  useEffect(() => {
    if ($.fn.DataTable.isDataTable('#neworderTable')) {
      $('#neworderTable').DataTable().destroy();
    }

    const getColumns = () => {
      const baseColumns = [
        { data: 'picklist_number', className: 'text-center' }
      ];

      if (accessToken === 'tss' || accessToken === 'tsc') {
        baseColumns.push(
          { data: 'reference_no', className: 'text-center' },
          { data: 'customer', className: 'text-center' },
          { data: 'route', className: 'text-center' }
        );
      } else {
        baseColumns.push(
          { data: 'route', className: 'text-center' }
        );
      }

      baseColumns.push(
        { data: 'picker' },
        { data: 'picklist_date', className: 'text-center' },
        { data: 'picking_status', className: 'text-center' },
        {
          data: null,
          render: function (data, type, row) {
            return `<a class="deductionbtn" title="view" href="${config.BASE_URL}/picking/view_picking/${row.picklist_number}"><i class="fa fa-eye"></i></a>`;
          },
        }
      );

      return baseColumns;
    };

    const table = $('#neworderTable').DataTable({
      paging: true,
      lengthMenu: [10, 20, 50],
      searching: true,
      ordering: false,
      pageLength: 50,
      info: true,
      responsive: false,
      autoWidth: false,
      language: {
        paginate: {
          first: 'First',
          last: 'Last',
          next: 'Next',
          previous: 'Previous',
        },
        search: 'Search:',
      },
      data: newSales,
      columns: getColumns(),
      columnDefs: [
        { targets: '_all', width: null }
      ],
      initComplete: function () {
        setTimeout(() => {
          $('#neworderTable thead th').each(function (idx) {
            $(this).css('width', colWidths[idx] + 'px');
          });
          addResizerListeners();
        }, 50);
      }
    });

    const addResizerListeners = () => {
      $('#neworderTable .th-resizer').remove();

      $('#neworderTable thead th').each(function (idx) {
        if (idx < $('#neworderTable thead th').length - 1) {
          const $th = $(this);
          const $resizer = $('<div class="th-resizer"></div>');
          $resizer.css({
            position: 'absolute',
            right: '-3px',
            top: '0',
            width: '6px',
            height: '100%',
            cursor: 'col-resize',
            zIndex: 999,
            userSelect: 'none',
            backgroundColor: 'transparent'
          });

          $th.css('position', 'relative');
          $th.append($resizer);

          $resizer.on('mousedown', function (e) {
            e.preventDefault();
            e.stopPropagation();
            startResizing(idx, e.originalEvent);
          });
        }
      });
    };

    return () => {
      if ($.fn.DataTable.isDataTable('#neworderTable')) {
        table.destroy();
      }
    };
  }, [newSales]);

  useEffect(() => {
    const styleSheet = document.createElement('style');
    styleSheet.textContent = `.th-resizer:hover { background-color: rgba(0, 123, 255, 0.3) !important; } .resizable-header { position: relative; user-select: none; } #neworderTable thead th { border-right: 1px solid #dee2e6; }`;
    document.head.appendChild(styleSheet);
    return () => {
      if (document.head.contains(styleSheet)) {
        document.head.removeChild(styleSheet);
      }
    };
  }, []);

  return (
    <div>
      <Header />
      <nav className="breadcrumbs">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">
              <a href="#"><i className="fa fa-home"></i> </a>
              <span className="last-crumb">Picking History</span>
            </div>
          </div>
        </div>
      </nav>
      <div className="main-container">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">
              <div className='dashboard picking-history-table'>
                <div className="verical-scrl-wrapper picking-history" id="style-3">
                  <table className="table table-bordered dataTable resizable resizable-columns" id="neworderTable" ref={tableRef}>
                    <thead>
                      <tr>
                        {["Picklist Number", ...(accessToken === 'tss' || accessToken === 'tsc' ? ["Order ID", "Customer Name", "Route Name"] : ["Route Name"]), "Picker", "Picklist Date", "Picking Status", "Action"].map((header, idx, arr) => (
                          <th
                            key={header + idx}
                            className="resizable-header"
                            style={{
                              width: colWidths[idx] || 120,
                              minWidth: 50,
                              position: "relative",
                              padding: "8px"
                            }}
                          >
                            {header}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {newSales.map((item, index) => (
                        <tr key={index}>
                          {Array.from({ length: colWidths.length }).map((_, colIdx) => (
                            <td key={colIdx}></td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PickingHistory;